import config from '../config/default/config.json';
export default config;


// WEBPACK FOOTER //
// ../node_modules/@os/finance-model/src/config.js